import dayjs from 'dayjs';

export const startWeek = 1;
export const setup = () => {
  dayjs.locale('en', {
    weekStart: startWeek,
  });
};
